import React from 'react'

import { ReactComponent as PencilIcon } from '@app/assets/Small/Outline/Pencil.svg'
import { Button } from '@app/lib/inputs/Button/Button'
import './index.scss'
import { useMobile } from '@app/services/useMobile'

export function EditButton({ onStartEdit }: { onStartEdit: React.MouseEventHandler }) {
  // todo: move over finalized ModernChat & Button code from customer portal. then this is no longer needed:
  const { isMobile } = useMobile()
  const height = isMobile ? '1.5rem' : '1.25rem'
  const width = isMobile ? '1.5rem' : '1.25rem'

  return (
    <Button
      color={'secondary'}
      leftIcon={<PencilIcon height={height} width={width} />}
      size={isMobile ? 'md' : 'sm'}
      variant='ghost'
      onClick={onStartEdit}
      alt='bearbeiten'
    >
      BEARBEITEN
    </Button>
  )
}
